import React from "react";

interface PublicRouteProps {
	// eslint-disable-next-line
	component: React.ComponentType<any>;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({
	component: Component,
}) => {
	return <Component />;
};
